import { Injectable } from '@angular/core';
import { urls, payloads } from '../../common/model/properties';
import { FieldValidateService } from '../../common_services/fieldvalidate.service';

import { ConfigProvider } from '../../shared/services/configprovider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SecureStorageService } from '../../secure-storage.service';
import { Observable } from 'rxjs';

@Injectable()
export class AccountProfileService {

    SKIP_NPI_VALIDATION = false;
    SKIP_TAXID_VALIDATION = false;


    private forgotUser: any = '';
    encodedAddress1: any;
    encodedAddress2: any;
    props:any;
    constructor(private http: HttpClient, private fieldValidator: FieldValidateService,
        private configProvider:ConfigProvider,
        private secureStorage:SecureStorageService) { 
            this.props = configProvider.getProps();
        }

    getUserProfile(userName, callBack: (sucess: boolean, message: string) => void) {

        // const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        // const headers = new HttpHeaders({
        //     'Content-Type': 'application/json',
        //     'Authorization': 'Bearer ' + ppjwt.access_token
        // });
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({'Authorization': 'Bearer ' +  ppjwt.access_token});

        this.http.get(urls.accountProfileUrl, { headers: headers })
            .subscribe(
                (resp) => {
                    callBack(true, resp['user'][0]);
                },
                err => {
                    callBack(false, 'Error while getting the profile : ');
                }
            );
    }
    getUserProfile2( userName): Promise<any> {
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({
            'Accept':'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        return this.http.get( urls.accountProfileUrl, {headers: headers}).toPromise();
    }

   

    updateSecurityQuestion(
        question1,
        question2,
        answer1,
        answer2,
        cred,
        callBack: (sucess: boolean, message: string) => void) {
        let id = this.secureStorage.getSecureInfoInSessionStorage('JSESSIONID');
        sessionStorage.removeItem('id');

        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));

        const headers = new HttpHeaders({
            'Accept': '*/*',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });

        const fullQuestionPayload = {
            secret: cred,
            question1: question1,
            answer1: answer1,
            question2: question2,
            answer2: answer2
        };

        this.http.post(urls.updateUserSecurityQuestions, fullQuestionPayload, { headers: headers, responseType:'text', withCredentials: true })
            .subscribe(
                (resp) => {
                    callBack(true, resp);
                },
                err => {
                    callBack(false, 'Error while persisting user challenges questions');
                }
            );
    }

    updateData(registerDataPayload, callBack: (sucess: boolean, message: string) => void) {

        
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        //const registerUserPayload = this.constructRegisterUserEmailPayload();
        // this.updateUserEmailId((registerDataPayload.userName), registerDataPayload.email, (success: boolean, message: string) => {
        //     if (success) {
                this.http.put(urls.updateDataUrl, registerDataPayload, { headers: headers,responseType:'text' })
                    .subscribe(
                        (resp:any) => {
                            callBack(true, resp);
                        },
                        err => {
                            callBack(false, err);
                        }
                    );
          //  }
       // });
    }


    parseUspsAdress(uspsResponse) {
        // const parser = new DOMParser();
        // const xmlDoc = parser.parseFromString(uspsResponse, 'text/xml');
        try {
        //     const addressModel = {};
        //     const addressElement = xmlDoc.getElementsByTagName('Address')[0];
        //     if (!addressElement.getElementsByTagName('Error')[0]) {
        //         addressModel['address1'] = this.extractValueFromNode(addressElement, 'Address2');
        //         addressModel['address2'] = this.extractValueFromNode(addressElement, 'Address1');
        //         addressModel['city'] = this.extractValueFromNode(addressElement, 'City');
        //         addressModel['state'] = this.extractValueFromNode(addressElement, 'State');
        //         addressModel['zip'] = this.extractValueFromNode(addressElement, 'Zip5');
        //         return addressModel;
        //     }
        // } catch (e) { }
        let resp = {}
        if(uspsResponse.Addresses.length > 0){
            uspsResponse.Addresses.forEach(each =>{
                if(each.ServiceGenericCode == "CODED"){
                    resp = uspsResponse.Addresses[0];
                }
            })
            
        }
        if(Object.keys(resp).length > 0){
            return resp;

        }
        } catch (e) { }
    }

    extractValueFromNode(xmlDoc, key) {
        let value = '';
        try {
            value = xmlDoc.getElementsByTagName(key)[0].textContent;
        } catch (e) { }
        return value;
    }

    doUspsValidation(model, callBack: (sucess: boolean, message) => void) {

         // usps address validation for #
        //  let payLoad = payloads.uspsPayLoad;

        //  if (model.address1.indexOf('#') != -1 || model.address2.indexOf('#') != -1) {
        //      this.encodedAddress1 = model.address1.replace('#', '');
        //      this.encodedAddress2 = model.address2.replace('#', '');
        //      payLoad = payLoad.replace('#ADDRESS2#', this.encodedAddress1);
        //      payLoad = payLoad.replace('#ADDRESS1#', this.encodedAddress2);
        //  }else{
        //      payLoad = payLoad.replace('#ADDRESS2#', model.address1);
        //      payLoad = payLoad.replace('#ADDRESS1#', model.address2);
        //  }
        // payLoad = payLoad.replace('#CITY#', model.city);
        // payLoad = payLoad.replace('#STATE#', model.state);
        // payLoad = payLoad.replace('#ZIP#', model.zip);

        let payload = {
            "address1" :  model.address1.replace('#', ''),
            "address2" : model.address2.replace('#', ''),
            "city" : model.city,
            "state" : model.state,
            "zip5" : model.zip
            }

        // const headers = new Headers();
        // headers.set('Content-Type', 'text/xml;charset=UTF-8');
        // headers.set('Accept', 'application/xml');
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));

        const headers = new HttpHeaders({
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        this.http.post(urls.userUspsValidateUrl , payload,{headers:headers})
            .subscribe(
                (response) => {
                    const addressModel = this.parseUspsAdress(response);
                    if (addressModel) {
                        callBack(true, addressModel);
                    } else {
                        callBack(false, addressModel);
                    }
                },
                err => {
                    callBack(false, err);
                }
            );
    }

    validateNPI(npivalue, callBack: (success: boolean, message: string) => void) {

        if (npivalue === '') {
            callBack(true, '');
            return;
        }
        if (this.fieldValidator.validateNumeric(npivalue.toString(), 10)) {
            if (this.SKIP_NPI_VALIDATION) {
                callBack(true, '');
                return;
            }

            const headers = new HttpHeaders({
            });

            this.http.get(urls.altIdNews + npivalue, { headers: headers }).subscribe((data:any) => {
                if (data.validityFlag === 1) {
                    callBack(true, '');
                } else {
                    callBack(false, 'Invalid NPI');

                }
            }, (err) => {
                callBack(false, err);
            });

        } else {
            callBack(false, 'The length of NPI should be 10 digits');
        }
    }

    validateTaxId(taxId, callBack: (sucess: boolean, message: string) => void) {

        if (taxId === '') {
            callBack(true, '');
            return;
        }
        if (this.fieldValidator.validateNumeric(taxId, 9)) {
            if (this.SKIP_TAXID_VALIDATION) {
                callBack(true, '');
                return;
            }

            const headers = new HttpHeaders({
            });

            this.http.get(urls.altIdNews + taxId, { headers: headers }).subscribe((data:any) => {

                if (data.validityFlag === 1) {
                    callBack(true, '');
                } else {
                    callBack(false, 'Invalid Tax ID');
                }
            }, (err) => {
                callBack(false, err);
            });
        } else {
            callBack(false, 'The length of TaxId should be 9 digits');
        }
    }

   validateNPIAndTaxId(npivalue, taxId, callBack: (success: boolean, message: string) => void) {

        if (npivalue === '' || taxId === '') {
           if (npivalue === '') {
                callBack(true, '');
            }

            if (taxId === '') {
                callBack(true, '');
            }

            return;
        }

        if (this.fieldValidator.validateNumeric(npivalue.toString(), 10)) {
            if (this.SKIP_NPI_VALIDATION) {
                callBack(true, '');
                return;
            }

            const headers = new HttpHeaders({
            });

            const endPoint = urls.isValidProviderNpiAndTaxId + "npi=" + npivalue + "&taxId=" + taxId;

            this.http.get(endPoint, { headers: headers }).subscribe((data:any) => {
                if (data === true) {
                    callBack(true, '');
                } else {
                    callBack(false, 'Invalid NPI or Tax ID');

                }
            }, (err) => {
                callBack(false, err);
            });
            
            // this.http.get(urls.altIdNews + npivalue, { headers: headers }).subscribe((data:any) => {
            //     if (data.validityFlag === 1) {
            //         callBack(true, '');
            //     } else {
            //         callBack(false, 'Invalid NPI');

            //     }
            // }, (err) => {
            //     callBack(false, err);
            // });

        } else {
            callBack(false, 'The length of NPI should be 10 digits');
        }
    }
    
    getSecurityQuestions(): Observable<any> {
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));

        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        return this.http.get(urls.getSecurityQuestionsUrlApi, { headers: headers });
    }

    
    getNewUserToken(cred): Observable<any> {
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({
            'Accept':'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        const payload = {
            "password": cred 
        };

        return this.http.post(urls.getNewUserToken, payload, {headers: headers});
    }

    removeDocAttributes() {
        const cookies = document.cookie;

        for (let i = 0; i < cookies.split(';').length; ++i) {
            const myCookie = cookies[i];
            const pos = myCookie.indexOf('=');
            const name = pos > -1 ? myCookie.substr(0, pos) : myCookie;
            document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
    }

    // updateUserEmailId(userName, emailId, callBack: (sucess: boolean, message: string) => void) {
    //     let payload = payloads.registerEmailPayload.replace('USER_NAME', userName);
    //     payload = payload.replace('EMAIL_ID', emailId);

    //     // let headers = new Headers();
    //     // let ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
    //     // headers.set( 'Authorization', 'Bearer ' +  ppjwt.access_token );
    //     const token: any = this.secureStorage.getSecureInfoInLocalStorage('clientCredentials_token');
    //     const headers = new HttpHeaders({
    //         'Accept': 'application/json',
    //         'Authorization': 'Bearer ' + token
    //     });
    //     // const headers = new Headers();
    //     // headers.set( 'Authorization', this.props.wso_authorization );
      
    //     this.http.post( urls.updateEmailId, payload, { headers: headers ,responseType:'text'} )
    //         .subscribe(
    //             (resp) => {
    //                 callBack(true, '');
    //             },
    //             err => {
    //                 callBack(false, 'Error while changing the EmailID : ');
    //             }
    //         );
    // }

    getStatesList() {
        // const headers = new Headers();
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        // headers.set('Content-Type', 'application/json');
        // headers.set('Authorization', 'Bearer ' + ppjwt.access_token);
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });
        const userObj = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        let path = urls.getStates;
        return this.http.get(path, { headers: headers })
    }

    getFilledSecurityQuestions() {
        const ppjwt = JSON.parse(this.secureStorage.getSecureInfoInLocalStorage('currentUser'));
        const headers = new HttpHeaders({
            'Accept':'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + ppjwt.access_token
        });

        return this.http.get(urls.getFilledSecurityQuestions, {headers: headers});
    }

   
}
